module.exports = __webpack_public_path__ + "img/employee-2.f895e4a5.jpg";